import React from 'react'
import PropTypes from 'prop-types'

import { Avatar } from '../../Common'

export const MessageAgent = ({ type, text, name, className }) => (
  <React.Fragment>
    <Avatar type={type} agentName={name} />
    <div className={className('body')}>{text}</div>
  </React.Fragment>
)

MessageAgent.propTypes = {
  name: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  className: PropTypes.func.isRequired,
}

export default MessageAgent
